import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook to fetch editable site content from CMS.
 * Returns a function c(key, defaultText) that returns CMS value or default.
 */
export const useSiteContent = (page) => {
  const [content, setContent] = useState({});

  useEffect(() => {
    if (!page) return;
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/site-content/${page}`);
        if (response.data?.content) {
          setContent(response.data.content);
        }
      } catch (error) {}
    };
    fetchContent();
  }, [page]);

  // Return CMS content if set, otherwise default
  const c = (key, defaultText) => content[key] || defaultText;

  return c;
};
